<template>
  <el-card header="告警信息">
    <el-row :gutter="20" type="flex" justify="space-between">
      <el-col>
        <div class="number-box" @click="showOfflines">
          <span class="title">离线设备</span>
          <div class="number color-error" v-if="record.offline > 0">{{record.offline}}台</div>
          <div class="number" v-else>无</div>
        </div>
      </el-col>
      <el-col>
        <div class="number-box" @click="showDevices('1')">
          <div class="title">风机异常</div>
          <div class="number color-error" v-if="record.fanError > 0">{{record.fanError}}台</div>
          <div class="number" v-else>无</div>
        </div>
      </el-col>
      <el-col>
        <div class="number-box" @click="showDevices('2')">
          <span class="title">高温报警</span>
          <div class="number color-error" v-if="record.highTempError > 0">{{record.highTempError}}台</div>
          <div class="number" v-else>无</div>
        </div>
      </el-col>
      <el-col>
        <div class="number-box" @click="showDevices('5')">
          <span class="title">传感器异常</span>
          <div class="number color-error" v-if="record.sensorError > 0">{{record.sensorError}}台</div>
          <div class="number" v-else>无</div>
        </div>
      </el-col>
<!--      <el-col>-->
<!--        <div class="number-box" @click="showDevices('3')">-->
<!--          <span class="title">无纺布更换提醒</span>-->
<!--          <div class="number color-error" v-if="record.clothWarn > 0">{{record.clothWarn}}台</div>-->
<!--          <div class="number" v-else>无</div>-->
<!--        </div>-->
<!--      </el-col>-->
    </el-row>
  </el-card>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";

export default {
  name: "ConsoleWarnings",
  extends: BaseVue,
  data() {
    return {
      record: {}
    }
  },
  created() {
    this.postForm("/device-status/compWarningTotal").then((dr) => {
      this.record = dr.bean;
    });
  },
  methods: {
    showOfflines(){
        this.$router.push("/myDeviceList?online=false")
    },
    showDevices(warningType) {
      this.$router.push("/myDeviceList?warningType="+warningType);
    }
  }
}
</script>

<style lang="scss" scoped>
.number-box{
  border: 1px solid #eaeaea;
  text-align: center;
  color: #fff;
  border-radius: 5px;
  padding: 15px;
  cursor: pointer;
  background-color: #2db7f5;
  .title{
    display: block;
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
  }
  .number{
    font-size:18px;
    font-weight: bold;
    line-height: 30px;
  }
}
</style>